import * as React from 'react';

import type {
    GetAccountBilling_accountBilling_currentPlan as AccountPlan,
    SubscriptionFragment,
} from 'nutshell-graphql-types';

import {AnnualSavingsPill} from '../add-ons/annual-savings-pill';

export const getAddOnsIncludedInPlan = (plan?: AccountPlan | null) => {
    // @ts-expect-error
    const includedAddOns = [];
    const addOns = ['nutshellIq', 'revenueBooster', 'smsCampaigns', 'quotes', 'nutshellAdvisor'];
    addOns.forEach((addOn) => {
        // @ts-expect-error
        if (plan && plan[addOn]) {
            // @ts-expect-error
            includedAddOns.push(plan[addOn]);
        }
    });

    // @ts-expect-error
    return includedAddOns;
};

export const getAnnualSavings = (subscription: SubscriptionFragment) => {
    let savings = null;
    switch (subscription.product) {
        case 'NUTSHELL_ADVISOR':
            savings = '$50';
            break;
        case 'CRM':
            savings = '15%';
            break;
        default:
            return null;
    }

    return <AnnualSavingsPill savings={savings} />;
};

export const getPlanDetailText = (subscription: SubscriptionFragment) => {
    switch (subscription.product) {
        case 'CRM':
            return `${subscription.quantity.toLocaleString()} ${
                subscription.quantity === 1 ? 'user' : 'users'
            }`;
        case 'MARKETING':
            return `${subscription.productQuantity.toLocaleString()} ${
                subscription.productQuantity === 1 ? 'contact' : 'contacts'
            }`;
        case 'SMS_CAMPAIGNS':
            return `${subscription.productQuantity.toLocaleString()} ${
                subscription.productQuantity === 1 ? 'text message' : 'text messages'
            }`;
        case 'NUTSHELL_IQ':
            return `${subscription.productQuantity.toLocaleString()} ${
                subscription.productQuantity === 1 ? 'credit' : 'credits'
            }`;
        case 'INBOX':
            return `${subscription.quantity.toLocaleString()} ${
                subscription.quantity === 1 ? 'seat' : 'seats'
            }`;
        case 'QUOTES':
        case 'NUTSHELL_ADVISOR':
            return subscription.isFake
                ? 'Entire company, included for current plan'
                : 'Entire company';
        case 'REVENUE_BOOSTER':
        default:
            return null;
    }
};
